// Blog post data - SEO optimized content for Strawberry Island
export const blogPosts = [
  {
    id: 'things-to-do-in-tofino',
    slug: 'things-to-do-in-tofino',
    title: 'Things To Do In Tofino: Your Ultimate Guide to Strawberry Island Adventures',
    excerpt: 'Discover the best things to do in Tofino, BC! From fishing charters to cabin stays, explore Strawberry Island and surrounding adventures.',
    author: 'Joel - Strawberry Island',
    date: '2025-01-15',
    category: 'Travel Guide',
    image: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/s6dm6wnn_2strawberryislandarial.png',
    content: `
# Things To Do In Tofino: Your Ultimate Guide to Strawberry Island Adventures

Are you planning a trip to Tofino, BC and wondering about the best things to do? Look no further! Strawberry Island offers the perfect blend of adventure, relaxation, and natural beauty just 30 seconds from downtown Tofino.

## Top Activities at Strawberry Island

### 1. World-Class Fishing Charters
Experience some of the best fishing on the West Coast! Our charters target:
- Halibut (up to 200+ lbs!)
- Salmon (Chinook, Coho, Sockeye)
- Lingcod and Rockfish

**Available Tours:** 4-hour, 6-hour, and 8-hour charters on our two boats, Screaming Eagle and Seahorse.

### 2. Unique Floating Cabin Rentals
Stay in one of our three floating cabins:
- **Halibut House** - Perfect for families (sleeps 4-6)
- **Seabass Suite** - Romantic couples retreat (sleeps 2-4)
- **Yellow House** - Adventure seekers paradise (sleeps 4-6)

Each cabin features a full kitchen, bathroom with hot water, and stunning water views!

### 3. Island Tours & Wildlife Watching
Explore the pristine waters around Tofino:
- Bear watching along the shoreline
- Whale encounters (Gray, Humpback, Orcas)
- Sea lion colonies
- Bald eagles and seabirds

### 4. Hot Springs Cove Tours
Visit one of BC's most spectacular natural wonders! Our tours include:
- Scenic boat ride through protected waters
- 30-minute rainforest boardwalk
- Seven natural geothermal hot spring pools
- Wildlife spotting opportunities

### 5. Historic Island Tours
Learn about Tofino's rich maritime history and indigenous heritage with our guided tours.

## Why Choose Strawberry Island?

Located just a quick water taxi ride from downtown Tofino, Strawberry Island offers:
- ✅ Convenient location
- ✅ Experienced local guides
- ✅ Family-friendly activities
- ✅ All equipment provided
- ✅ Stunning scenery

## Book Your Tofino Adventure Today!

Whether you're looking for an adrenaline-filled fishing charter, a peaceful cabin retreat, or educational island tours, Strawberry Island has something for everyone.

**Contact us:** joel@fishingtofino.net | 250-317-0600

---

*Ready to experience the best of Tofino? Book your Strawberry Island adventure today!*
    `,
    metaDescription: 'Discover the top things to do in Tofino, BC! Strawberry Island offers fishing charters, cabin rentals, hot springs tours, and wildlife adventures. Book now!',
    keywords: 'things to do in Tofino, Tofino activities, Strawberry Island, Tofino fishing, cabin rentals Tofino, hot springs tours'
  },
  {
    id: 'more-than-fishing-tours',
    slug: 'more-than-fishing-tours-and-more',
    title: 'More Than Fishing: Island Tours, Hot Springs & Adventures in Tofino',
    excerpt: 'Strawberry Island offers more than just fishing! Explore our island tours, hot springs adventures, cabin stays, and unique Tofino experiences.',
    author: 'Joel - Strawberry Island',
    date: '2025-01-20',
    category: 'Adventures',
    image: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/75n53wh9_IMG_1476.jpeg',
    content: `
# More Than Fishing: Island Tours, Hot Springs & Adventures in Tofino

While Strawberry Island is renowned for world-class fishing charters, we offer so much more! Discover the full range of adventures waiting for you in Tofino, BC.

## Island Tour Experiences

### Customized Island Adventures
Design your perfect day with our custom island tours:
- **Beach Hopping** - Visit multiple pristine beaches and hidden coves
- **Photography Tours** - Capture stunning landscapes and wildlife
- **Sunset & Sunrise Tours** - Experience magical golden hour views
- **Wildlife Spotting** - See sea otters, seals, eagles, and maybe whales!

### Historic Island Tours
Step back in time and learn about:
- Indigenous heritage and totem poles
- Early settlers and maritime history
- Local legends and cultural significance
- Historic landmarks around Tofino

**Pricing:** $50/person | Morning and evening tours available

## Hot Springs Cove Tours

One of BC's most spectacular natural wonders awaits! Our Hot Springs Cove tours include:

1. **Scenic Boat Ride** - Cruise through pristine waters to Maquinna Provincial Park
2. **Rainforest Boardwalk** - 30-minute walk through ancient old-growth forest
3. **Geothermal Pools** - Seven natural hot pools overlooking the ocean
4. **Wildlife Viewing** - Spot whales, sea lions, and bears en route

Perfect for couples, families, and solo adventurers seeking relaxation and natural beauty!

## Cabin Stays & Island Living

Experience unique floating cabin life:
- Wake up to ocean views
- Full kitchen and modern amenities
- Perfect base for exploring Tofino
- Pet-friendly options available

Combine cabin stays with any tour for the ultimate island experience!

## Water Taxi & Transportation Services

Convenient access to Strawberry Island and beyond:
- On-demand water taxi service
- Just 30 seconds from downtown Tofino
- Boat moorage available
- Competitive rates

## Wellness & Yoga Retreats

Find your zen with Nicole Rice Wellness:
- Beach yoga classes
- Meditation sessions
- Holistic wellness programs
- Multi-day retreats available

## Prawning & Crabbing Adventures

Get hands-on with local seafood:
- Pull prawn and crab traps
- Learn from experienced fishermen
- Take home fresh catch
- Cooked right on the boat in garlic butter!

## Book Your Complete Tofino Experience

Don't limit yourself to just fishing! Strawberry Island offers a complete Tofino vacation experience with activities for everyone.

**Contact:** joel@fishingtofino.net | 250-317-0600

---

*From fishing charters to hot springs, island tours to cabin stays - experience it all at Strawberry Island!*
    `,
    metaDescription: 'Discover all Strawberry Island has to offer beyond fishing! Island tours, hot springs adventures, cabin rentals, yoga retreats & more in Tofino, BC.',
    keywords: 'Tofino tours, hot springs Tofino, island adventures, Strawberry Island, things to do Tofino, cabin rentals, water taxi Tofino'
  },
  {
    id: 'water-taxi-moorage-services',
    slug: 'convenient-water-taxi-and-moorage-services',
    title: 'Convenient Water Taxi and Boat Moorage Services in Tofino',
    excerpt: 'Need water taxi service or boat moorage in Tofino? Strawberry Island offers reliable, affordable transportation and secure moorage facilities.',
    author: 'Joel - Strawberry Island',
    date: '2025-01-25',
    category: 'Services',
    image: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/rdnpqov5_IMG_2911.JPG',
    content: `
# Convenient Water Taxi and Boat Moorage Services in Tofino

Planning a visit to Tofino and need reliable water transportation or secure boat moorage? Strawberry Island offers both services with competitive rates and exceptional convenience!

## Water Taxi Service

### Quick & Reliable Transportation
Our water taxi service provides:
- **Fast transit** - Just 30 seconds from downtown Tofino to Strawberry Island
- **On-demand service** - Call Pearl an hour before pickup
- **Affordable rates** - Competitive pricing for guests and visitors
- **Safe transport** - Experienced local operators
- **All weather service** - Operating year-round (weather permitting)

### Perfect For:
✅ Cabin guests getting to/from Strawberry Island  
✅ Tour participants  
✅ Day visitors exploring the island  
✅ Residents needing mainland access  
✅ Emergency transportation needs

### How It Works:
1. Call or text: 250-317-0600
2. Request pickup time (1-hour notice preferred)
3. Meet at designated pickup point
4. Enjoy the quick, scenic ride!

## Boat Moorage Services

### Secure, Affordable Moorage
Need a safe place to dock your boat while exploring Tofino? We offer:

**Daily Moorage:**
- Competitive rates by boat length
- Protected moorage location
- Easy access to island facilities
- Walking distance to amenities

**Monthly Moorage:**
- Special discounted rates for extended stays
- Ideal for seasonal visitors
- Secure long-term docking
- Priority booking for cabins and tours

### Why Choose Strawberry Island Moorage?

🔹 **Prime Location** - Central Tofino Harbor access  
🔹 **Protected Waters** - Safe from ocean swells  
🔹 **Full Services** - Power, water, and waste disposal available  
🔹 **Security** - Monitored location  
🔹 **Convenience** - Walk to downtown Tofino or stay on island  

### Rates:
Contact us for current per-foot daily and monthly rates:
- **Email:** joel@fishingtofino.net
- **Phone:** 250-317-0600

## Combined Services Package

**Save when you book multiple services:**
- Water taxi + cabin stay
- Moorage + fishing charter
- Water taxi + island tour

## Accessibility & Convenience

Strawberry Island's location makes it the perfect hub for Tofino adventures:
- 30-second boat ride to downtown
- Access to all major Tofino attractions
- Floating homes community
- Full amenities on island

## Book Your Service Today

Whether you need a quick water taxi ride or long-term boat moorage, Strawberry Island has you covered!

**Contact Information:**
- **Email:** joel@fishingtofino.net
- **Phone:** 250-317-0600
- **Location:** Strawberry Island, Tofino, BC

---

*Convenient, reliable, and affordable water transportation and moorage services in Tofino!*
    `,
    metaDescription: 'Water taxi and boat moorage services in Tofino, BC. Strawberry Island offers reliable transportation and secure moorage. Competitive rates!',
    keywords: 'Tofino water taxi, boat moorage Tofino, water transportation, Strawberry Island, Tofino harbor, boat docking Tofino'
  },
  {
    id: 'hot-springs-tours-guide',
    slug: 'hot-springs-tours-complete-guide',
    title: 'Hot Springs Cove Tours: Complete Guide to Tofino\'s Natural Wonder',
    excerpt: 'Everything you need to know about Hot Springs Cove tours from Tofino. Booking tips, what to bring, and why Strawberry Island offers the best experience.',
    author: 'Joel - Strawberry Island',
    date: '2025-01-28',
    category: 'Tours',
    image: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/xzjoauet_IMG_2487.jpeg',
    content: `
# Hot Springs Cove Tours: Complete Guide to Tofino's Natural Wonder

Hot Springs Cove is one of British Columbia's most spectacular natural attractions, and Strawberry Island offers the best way to experience it! Here's your complete guide to this unforgettable adventure.

## What is Hot Springs Cove?

Located in Maquinna Provincial Park, Hot Springs Cove features:
- **Seven natural geothermal pools** cascading toward the ocean
- **Temperatures** ranging from warm to hot (up to 50°C/122°F)
- **Stunning ocean views** from the pools
- **Ancient old-growth rainforest** surrounding the springs
- **One of only four natural hot springs** on Vancouver Island

## The Strawberry Island Experience

### Getting There
Our tours include:
1. **Scenic boat ride** (approximately 1.5 hours each way)
2. **Wildlife viewing** en route - whales, sea lions, bears, eagles
3. **Protected waters** - comfortable ride in all seasons
4. **Experienced guides** sharing local knowledge

### The Rainforest Walk
- 30-minute boardwalk through old-growth forest
- Massive cedar and spruce trees
- Educational interpretation about local ecology
- Accessible path suitable for most fitness levels

### The Hot Springs
Seven natural pools to choose from:
- **Upper pools:** Hotter temperatures, intimate setting
- **Middle pools:** Perfect balance of heat and views
- **Lower pools:** Cooler water, ocean waves mixing in
- **Rocky setting:** Natural beauty and photo opportunities

## Tour Details

### What's Included:
✅ Round-trip boat transportation  
✅ Experienced local guide  
✅ Safety equipment  
✅ Wildlife viewing opportunities  
✅ Access to hot springs  
✅ Time to soak and explore (2-3 hours at destination)  

### Tour Duration:
- **Total time:** 6-8 hours
- **Boat ride:** 1.5 hours each way
- **At hot springs:** 2-3 hours
- **Flexibility:** Tours adjusted for tides and weather

### Pricing:
Contact for current rates and availability:
- **Email:** joel@fishingtofino.net
- **Phone:** 250-317-0600

## What to Bring

### Essential Items:
🎒 Swimsuit (wear under clothes)  
🎒 Towel  
🎒 Water shoes or sandals (rocks can be slippery)  
🎒 Water bottle  
🎒 Sunscreen and hat  
🎒 Camera (waterproof recommended)  
🎒 Light rain jacket (just in case)  

### Optional:
- Dry bag for valuables
- Snacks
- Waterproof phone case
- Change of clothes for boat ride back

## Best Time to Visit

### Year-Round Destination
Hot Springs Cove is accessible all year:

**Summer (June-September):**
- Warmest weather
- Longer days
- More boat traffic
- Book in advance!

**Fall (October-November):**
- Fewer crowds
- Storm watching opportunities
- Dramatic scenery
- Whale migration season

**Winter (December-March):**
- Most peaceful experience
- Unique combination of cold air and hot water
- Northern lights possible (rare)
- Special winter rates

**Spring (April-May):**
- Wildlife awakening
- Wildflowers blooming
- Gray whale migration
- Moderate crowds

## Tips for the Best Experience

### 1. Book Early
Hot Springs tours are popular! Reserve your spot:
- Summer: Book 1-2 weeks ahead
- Shoulder seasons: 3-7 days ahead
- Winter: More flexible, but still recommended

### 2. Check the Weather
While tours run year-round, weather affects:
- Sea conditions for the boat ride
- Comfort level at the springs
- Wildlife viewing opportunities

### 3. Arrive Early
- Meet 15 minutes before departure
- Use restroom before boarding
- Ask questions before leaving

### 4. Respect the Environment
- Pack out all trash
- Stay on designated paths
- Don't use soap in the springs
- Leave no trace

## Why Choose Strawberry Island?

### Local Expertise
- Family-operated for generations
- Intimate knowledge of the area
- Commitment to safety and sustainability
- Personalized service

### Smaller Groups
- More comfortable experience
- Better wildlife viewing
- Flexibility at the springs
- Personal attention from guides

### Convenient Location
- Just 30 seconds from downtown Tofino
- Easy meeting point
- Optional cabin packages
- Combine with other activities

## Frequently Asked Questions

**Q: Is it safe for children?**  
A: Yes! Families are welcome. Children should be comfortable on boats and able to walk 2km.

**Q: What if I can't swim?**  
A: No swimming required! Hot springs are pool-like. Life jackets provided on boat.

**Q: Are the springs accessible?**  
A: The boardwalk requires moderate mobility. The springs themselves involve some rock scrambling.

**Q: Can I go in winter?**  
A: Absolutely! Winter offers a unique experience with fewer crowds.

**Q: How hot are the springs?**  
A: Temperatures vary by pool, from warm (comfortable) to hot (50°C). Choose your comfort level!

## Book Your Hot Springs Adventure

Ready to experience this natural wonder? Contact Strawberry Island today!

**Reservations:**
- **Email:** joel@fishingtofino.net
- **Phone:** 250-317-0600
- **Website:** strawberry-island.com

---

*Experience Hot Springs Cove with Strawberry Island - Tofino's premier hot springs tour operator!*
    `,
    metaDescription: 'Complete guide to Hot Springs Cove tours from Tofino, BC. Book with Strawberry Island for the best hot springs experience. Tips, what to bring & more!',
    keywords: 'Hot Springs Cove, Tofino hot springs, hot springs tours, Maquinna Provincial Park, Strawberry Island tours, Vancouver Island hot springs'
  },
  {
    id: 'winter-storm-watching-tofino',
    slug: 'winter-storm-watching-tofino-cabin-getaway',
    title: 'Winter Storm Watching in Tofino: The Ultimate Cabin Getaway',
    excerpt: 'Experience dramatic Pacific storms from the comfort of a floating cabin. Discover why winter is the perfect time for a Tofino getaway at Strawberry Island.',
    author: 'Joel - Strawberry Island',
    date: '2025-02-01',
    category: 'Seasonal',
    image: 'https://customer-assets.emergentagent.com/job_berry-isle-reborn/artifacts/6eu8n3y8_IMG_7991.PNG',
    content: `
# Winter Storm Watching in Tofino: The Ultimate Cabin Getaway

Discover the raw power and beauty of Pacific winter storms from the unique vantage point of a floating cabin at Strawberry Island. Here's why winter might just be the best time to visit Tofino!

## Why Winter Storm Watching?

### The Spectacle
November through March brings dramatic Pacific storms:
- **Massive waves** crashing against rocky shores
- **Powerful winds** bending ancient trees
- **Dramatic skies** with constantly changing clouds
- **Raw natural power** that must be experienced

### The Comfort
Experience it all from your cozy floating cabin:
- Floor-to-ceiling windows with front-row views
- Full kitchen for hot meals and drinks
- Comfortable beds and modern amenities
- Safe, secure, and warm

## The Strawberry Island Advantage

### Unique Floating Cabins
Our cabins offer something hotels can't:
- **Direct water access** - Feel the gentle rocking
- **360-degree views** - Surrounded by nature
- **Private experience** - Your own island retreat
- **Authentic atmosphere** - Real island living

### Three Cabins to Choose From

**Halibut House** 🐟
- Best for families and groups
- Sleeps 4-6
- Spacious living areas
- Multiple viewing angles

**Seabass Suite** 🐠
- Perfect for couples
- Romantic ambiance
- Intimate setting
- Panoramic ocean views

**Yellow House** 🏡
- Bright and cheerful
- Great for small groups
- Modern amenities
- Adventure base camp

## What to Expect

### The Storms
Pacific winter storms are nature's theatre:
- **Wave heights:** Can reach 20-30 feet offshore
- **Wind speeds:** 40-60 km/h common, higher in peak storms
- **Duration:** Storms can last hours or days
- **Frequency:** Multiple storms per month November-March

### The Experience
A typical winter storm watching day:

**Morning:**
- Wake to dramatic skies
- Hot coffee with storm views
- Watch weather systems roll in

**Afternoon:**
- Peak storm activity
- Massive waves and dramatic clouds
- Wildlife seeking shelter

**Evening:**
- Spectacular sunsets (when clouds break)
- Cozy cabin evenings
- Sound of waves and wind

## Winter Activities Beyond Storm Watching

### Wildlife Viewing
Winter brings unique opportunities:
- **Gray whale migration** (February-April)
- **Bald eagle gatherings**
- **Storm petrels** riding the waves
- **Harbor seals** in protected coves

### Photography Paradise
Capture stunning images:
- Dramatic storm clouds
- Massive wave action
- Moody landscapes
- Wildlife in winter habitat

### Hot Springs Tours
Combine cold air with warm water:
- Incredible contrast experience
- Fewer tourists
- Peaceful journey
- Unique winter beauty

### Tofino Winter Events
- Storm watching festivals
- Culinary events
- Cozy local restaurants
- Art galleries and shops

## Special Winter Rates

### Off-Season Savings
We offer discounted rates for winter storm watching!

**Benefits:**
💰 Lower cabin rates  
💰 Flexible booking  
💰 Longer stays available  
💰 Last-minute deals  

**Contact for pricing:**
- **Email:** joel@fishingtofino.net
- **Phone:** 250-317-0600

## Planning Your Storm Watching Trip

### Best Months
- **November-December:** Early season storms
- **January-February:** Peak storm activity
- **March:** Transition period, still spectacular

### What to Bring
✅ Warm, waterproof clothing  
✅ Multiple layers  
✅ Good books or games  
✅ Camera equipment  
✅ Binoculars for wildlife  
✅ Your favorite beverages  

### What We Provide
✅ Full kitchen and cookware  
✅ Linens and towels  
✅ Hot water and heating  
✅ Water taxi transportation  
✅ Local recommendations  

## Safety & Comfort

### We've Got You Covered
- Experienced staff on-call 24/7
- Weather monitoring
- Safe, secure cabins
- Modern safety equipment
- Clear communication protocols

### Cabin Features
All cabins include:
- Full bathroom with hot shower
- Complete kitchen
- Heating system
- Emergency supplies
- Weather-resistant construction

## Why Guests Love Winter at Strawberry Island

### Real Reviews

*"Watching a massive storm from the floating cabin was absolutely incredible. Felt completely safe while experiencing raw nature's power!"* - Sarah & Mike, Vancouver

*"Best winter getaway ever! The combination of dramatic weather and cozy cabin comfort is perfect."* - Jennifer, Seattle

*"We saw whales during a storm! Unforgettable experience. Will definitely return next winter."* - Robert & Lisa, Calgary

## Combine Your Stay

### Package Opportunities
- Storm watching + hot springs tour
- Extended stays (3-7 nights)
- Multiple cabins for groups
- Add fishing charters (weather permitting)

## Book Your Winter Storm Watching Adventure

Don't miss this unique Tofino experience! Winter dates book up surprisingly fast.

### Reservation Information
- **Email:** joel@fishingtofino.net
- **Phone:** 250-317-0600
- **Website:** strawberry-island.com

### Booking Tips
- Book early for holiday periods
- Ask about last-minute availability
- Inquire about multi-night discounts
- Check weather forecasts (but embrace whatever comes!)

## Frequently Asked Questions

**Q: Is it scary in a storm?**  
A: Not at all! The cabins are extremely secure and the gentle rocking is soothing, not frightening.

**Q: What if the storm is too intense?**  
A: We monitor weather constantly. Safety is our priority. We can always arrange mainland transport if needed.

**Q: Can we still do activities?**  
A: Yes! Hot springs tours, fishing (weather-dependent), and protected water activities often available.

**Q: Are the cabins warm?**  
A: Absolutely! Full heating systems keep you cozy no matter how wild it gets outside.

**Q: What about power outages?**  
A: Cabins have backup systems and we're always on call.

## The Magic of Winter Storm Watching

There's something profoundly peaceful about witnessing nature's power from a place of safety and comfort. The combination of dramatic weather, cozy cabin life, and Strawberry Island's unique floating home experience creates memories that last a lifetime.

**Ready for your storm watching adventure?**

Contact Strawberry Island today and discover why winter might just be your new favorite season in Tofino!

---

*Winter storm watching at Strawberry Island - where nature's drama meets coastal comfort!*
    `,
    metaDescription: 'Winter storm watching in Tofino from floating cabins! Experience dramatic Pacific storms in comfort at Strawberry Island. Special off-season rates available.',
    keywords: 'winter storm watching Tofino, Tofino winter getaway, storm watching cabin, Strawberry Island winter, Pacific storms, Tofino off-season'
  }
];

export default blogPosts;
